import { useCallback, useMemo, useState } from 'react';

import type { TranslatableLabel } from '#src/app/shared/hooks/i18n';

const RESET_LABEL_TIMER = 3000;

type ShareData = {
	buttonLabel: TranslatableLabel;
};
type ShareActions = { afterShare: () => void };
type UseDefaultShareButtonResult = ModelHookResult<ShareData, ShareActions>;
type UseShareButtonArgs = {
	label: TranslatableLabel;
	successLabel?: TranslatableLabel;
};

export function useRoundShareIconButton({ label, successLabel }: UseShareButtonArgs): UseDefaultShareButtonResult {
	const [clickedState, setClickedState] = useState(false);

	const afterShare = useCallback(() => {
		if (successLabel) {
			setClickedState(true);
			window.setTimeout(() => {
				setClickedState(false);
			}, RESET_LABEL_TIMER);
		}
	}, [setClickedState, successLabel]);

	const buttonLabel = useMemo(
		() => (successLabel && clickedState ? successLabel : label),
		[clickedState, successLabel, label],
	);

	return {
		data: { buttonLabel },
		actions: { afterShare },
	};
}
